import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Testids } from '@mono/ui-selectors';
const parse = (json)=>{
    try {
        const v = JSON.parse(json);
        return v && typeof v === 'object' && !Array.isArray(v) ? v : {};
    } catch  {
        return {};
    }
};
// Where in the source the wording sits. Only these keys are surfaced: location
// and file identity, never the source's own text, so a restricted source shows
// nothing beyond what a location line already discloses.
const location = (ev)=>[
        ev.source_filename ? `File ${String(ev.source_filename)}` : null,
        ev.page_number != null ? `Page ${String(ev.page_number)}` : null,
        ev.section_number ? `Section ${String(ev.section_number)}` : null,
        ev.sheet_name ? `Sheet ${String(ev.sheet_name)}` : null,
        ev.row_number != null ? `Row ${String(ev.row_number)}` : null
    ].filter(Boolean).join(' · ') || 'No source location recorded';
/**
 * C2-08: the source occurrences behind a catalog entry — which accepted
 * candidates produced or resolved to it, what the extraction originally
 * proposed, what the reviewer changed, and where in the source it came from.
 * Read from the retained candidate rows, so it outlives the pricing-sheet job.
 */ export function EntryProvenanceSection({ entry, candidates }) {
    const rows = candidates.filter((c)=>c.acceptedEntryId === entry.id);
    return /*#__PURE__*/ _jsxs("div", {
        className: "space-y-2",
        "data-testid": Testids.deliveryRegistries.lcatEntryProvenance,
        children: [
            /*#__PURE__*/ _jsx("div", {
                className: "text-[length:var(--fs-ui-label)] font-medium uppercase tracking-[var(--ls-ui-eyebrow)] text-muted-foreground",
                children: "Source and review"
            }),
            /*#__PURE__*/ _jsxs("div", {
                className: "text-xs text-muted-foreground",
                children: [
                    "Intake: ",
                    entry.source === 'CANDIDATE' ? 'extraction' : 'manual entry',
                    " · v",
                    entry.version
                ]
            }),
            rows.length === 0 && /*#__PURE__*/ _jsx("p", {
                className: "text-xs text-muted-foreground",
                children: "No reviewed source occurrence on record."
            }),
            rows.map((c)=>{
                const ev = parse(c.evidenceJson);
                const changes = Object.keys(parse(c.correctionJson));
                return /*#__PURE__*/ _jsxs("div", {
                    className: "space-y-1 rounded-md border border-border p-2 text-xs",
                    "data-testid": Testids.deliveryRegistries.lcatEntryProvenanceRow,
                    children: [
                        /*#__PURE__*/ _jsx("div", {
                            children: location(ev)
                        }),
                        /*#__PURE__*/ _jsxs("div", {
                            className: "text-muted-foreground",
                            children: [
                                "Originally proposed as “",
                                c.title,
                                "”",
                                c.zouProjectId ? ` · project ${c.zouProjectId}` : ''
                            ]
                        }),
                        /*#__PURE__*/ _jsxs("div", {
                            className: "text-muted-foreground",
                            children: [
                                c.resolution === 'EXISTING' ? 'Resolved to this definition' : 'Accepted as a new definition',
                                changes.length > 0 ? ` · corrected: ${changes.join(', ')}` : ' · no corrections',
                                c.conflictAcknowledged ? ' · qualification conflict acknowledged' : ''
                            ]
                        })
                    ]
                }, c.id);
            })
        ]
    });
}
